export const getEnv = (): 'development' | 'production' | 'qa' => {
  const isLocal = globalThis.location.origin.includes('localhost');
  const isQa = globalThis.location.origin.includes('cte.ikeadt');

  if (isLocal) {
    return 'development';
  }

  if (isQa) {
    return 'qa';
  }

  return 'production';
};
